export const PARTIAL_PAYMENT = 'partial-payment';
export const SELECT_PAYMENT_PERIOD = 'select-payment-period';
export const TRANSFER_DETAILS = 'transfer-details';
